import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-skeleton-loader',
    templateUrl: './skeleton-loader.component.html',
    styleUrls: ['./skeleton-loader.component.css'],
    standalone: false
})
export class SkeletonLoaderComponent implements OnInit {

  @Input() Cwidth;
  @Input() Cheight;
  @Input() circle: boolean;
    constructor() { }

    ngOnInit() {
    }

    getSkeletonStyles(){
      const myStyles ={
        'width.px': this.Cwidth ? this.Cwidth: '',
        'height.px': this.Cheight ? this.Cheight: '',
        'border-radius.px': this.circle ? '50%' :''
      };
      return myStyles;
    }


}
